<template>
  <div class="listing" v-if="user">
    <header class="header">
      <div class="header__Search">
        <form @submit.prevent="filters.searchQuery = filters.search_query" class="search">
          <input
            class="search__Text"
            type="search"
            :placeholder="$store.getters.getStringTranslation('enterUsernameEnter')"
            v-model="filters.search_query"
          />
          <button class="search__Button">
            <icon name="search"></icon>
          </button>
        </form>
      </div>
    </header>
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">{{ $store.getters.getStringTranslation('users') }}</h1>

          <ul class="pageHeader__Meta" v-if="$route.name === 'Active users'">
            <li>
              <router-link class="button" :to="{ name: 'Add user' }"
                >{{ $store.getters.getStringTranslation('addUser') }}
              </router-link>
            </li>
            <li v-if="isSuperAdmin">
              <button class="button" @click="downloadAllUsers">
                {{ $store.getters.getStringTranslation('dlUsersCSV') }}
              </button>
            </li>
          </ul>
        </div>
      </header>

      <div class="tab">
        <div class="tab__MenuWrapper">
          <nav class="tab__Menu">
            <ul class="tab__MenuList--Settings">
              <li>
                <router-link :to="{ name: 'Active users' }">{{
                  $store.getters.getStringTranslation('users')
                }}</router-link>
              </li>
              <li v-if="pending">
                <router-link :to="{ name: 'Pending users' }">
                  {{ $store.getters.getStringTranslation('pendingUsers') }}
                  <strong v-if="pending.length > 0">({{ pending.length }})</strong>
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Invite users' }">{{
                  $store.getters.getStringTranslation('inviteUsers')
                }}</router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="tab__Wrapper">
          <router-view :search="filters.searchQuery"></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HTTP from '@/http-common.js'

export default {
  name: 'UsersListing',
  data() {
    return {
      filters: {
        search_query: '',
        searchQuery: '',
      },
    }
  },
  watch: {
    $route(to) {
      this.checkAdmin(to)
    },
    'filters.search_query'(value) {
      if (value.length === 0) {
        this.filters.searchQuery = this.filters.search_query
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.accounts.user
    },
    pending() {
      return this.$store.state.accounts.users.pending
    },
    isAdmin() {
      if (this.user.is_admin || this.user.is_org_admin) return true
      return false
    },
    isSuperAdmin() {
      if (this.user.is_admin) return true
      return false
    },
  },
  methods: {
    checkAdmin(path = this.$route.name) {
      if (!this.isAdmin && path !== 'Account') this.$router.push({ name: 'Account' })
    },
    downloadAllUsers() {
      HTTP.get('download_all_users_csv').then((response) => {
        let fileContent = 'data:text/csv;charset=utf-8,'
        fileContent += response.data
        const encodedUri = encodeURI(fileContent)
        window.open(encodedUri)
      })
    },
  },
  mounted() {
    this.checkAdmin()
  },
}
</script>
